import React, { useState, useEffect, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { EMAILJS } from '../../data/siteData';

// ---- AcademyModal ----
// PMG Technology Academy enrollment — $9.99 USDT payment required

const USDT_WALLET = "TY42NfmedSPM3BNTHuTWzEk6EKzvBsveYZ"; // TODO: Replace with your real USDT (TRC20) wallet address

export default function AcademyModal({ open, onClose }) {
  const formRef = useRef();
  const [step, setStep] = useState(1); // 1 = payment info, 2 = enrollment form
  const [form, setForm] = useState({
    full_name: '', sex: '', nationality: '',
    postal_code: '', email: '',
    tech_skills: '', date: '',
    tx_hash: '', screenshot_note: '',
  });
  const [status, setStatus] = useState('idle');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  // Reset on close
  useEffect(() => {
    if (!open) { setStep(1); setStatus('idle'); }
  }, [open]);

  if (!open) return null;

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const copyWallet = () => {
    navigator.clipboard.writeText(USDT_WALLET);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      await emailjs.sendForm(
        EMAILJS.serviceId,
        EMAILJS.academyTemplateId,
        formRef.current,
        EMAILJS.publicKey
      );
      setStatus('success');
    } catch (err) {
      console.error('EmailJS error:', err);
      setStatus('error');
    }
  };

  const inputStyle = {
    width: '100%', padding: '11px 14px',
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(201,168,76,0.15)',
    borderRadius: '4px', color: 'var(--text-primary)',
    fontSize: '14px', fontFamily: 'var(--font-sans)',
    outline: 'none', transition: 'border-color 0.2s',
  };
  const labelStyle = {
    display: 'block', fontSize: '12px',
    letterSpacing: '0.06em', textTransform: 'uppercase',
    color: 'var(--text-secondary)', marginBottom: '7px',
  };
  const focus = e => e.target.style.borderColor = 'var(--gold)';
  const blur  = e => e.target.style.borderColor = 'rgba(201,168,76,0.15)';
  const req   = <span style={{ color: 'var(--gold)', marginLeft: '2px' }}>*</span>;

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.8)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px', backdropFilter: 'blur(4px)',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#141720',
        border: '1px solid rgba(201,168,76,0.2)',
        borderRadius: '12px', width: '100%', maxWidth: '560px',
        maxHeight: '90vh', overflowY: 'auto',
        padding: '40px', position: 'relative',
      }}>

        {/* Close */}
        <button onClick={onClose} style={{
          position: 'absolute', top: '16px', right: '16px',
          background: 'rgba(255,255,255,0.06)', border: 'none',
          borderRadius: '50%', width: '32px', height: '32px',
          color: 'var(--text-secondary)', fontSize: '18px',
          cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>×</button>

        {/* Header */}
        <div style={{ marginBottom: '24px' }}>
          <span style={{ fontSize: '11px', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--gold)' }}>
            PMG Technology Academy
          </span>
          <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: '24px', fontWeight: 700, color: 'var(--text-primary)', marginTop: '6px' }}>
            Enrollment — $9.99 USDT
          </h2>

          {/* Step indicator */}
          <div style={{ display: 'flex', gap: '8px', marginTop: '16px', alignItems: 'center' }}>
            {['Payment', 'Your Details'].map((s, i) => (
              <React.Fragment key={i}>
                <div style={{
                  display: 'flex', alignItems: 'center', gap: '6px',
                  fontSize: '12px', fontWeight: step === i + 1 ? 500 : 400,
                  color: step === i + 1 ? 'var(--gold)' : step > i + 1 ? '#1D9E75' : 'var(--text-secondary)',
                }}>
                  <div style={{
                    width: '22px', height: '22px', borderRadius: '50%',
                    background: step === i + 1 ? 'rgba(201,168,76,0.15)' : step > i + 1 ? 'rgba(29,158,117,0.15)' : 'rgba(255,255,255,0.05)',
                    border: `1px solid ${step === i + 1 ? 'var(--gold)' : step > i + 1 ? '#1D9E75' : 'rgba(255,255,255,0.1)'}`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '11px', fontWeight: 500,
                    color: step === i + 1 ? 'var(--gold)' : step > i + 1 ? '#1D9E75' : 'var(--text-secondary)',
                  }}>
                    {step > i + 1 ? '✓' : i + 1}
                  </div>
                  {s}
                </div>
                {i === 0 && <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.08)' }} />}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* ---- STEP 1: Payment ---- */}
        {step === 1 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={{
              background: 'rgba(201,168,76,0.06)',
              border: '1px solid rgba(201,168,76,0.2)',
              borderRadius: '8px', padding: '20px',
            }}>
              <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '16px', lineHeight: 1.6 }}>
                Send exactly <strong style={{ color: 'var(--gold)' }}>$9.99 USDT</strong> to the wallet address below. We accept <strong style={{ color: 'var(--text-primary)' }}>TRC20 (Tron network)</strong> only.
              </div>

              {/* Wallet address */}
              <div style={{ marginBottom: '12px' }}>
                <div style={{ fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-secondary)', marginBottom: '8px' }}>
                  USDT Wallet Address (TRC20)
                </div>
                <div style={{
                  display: 'flex', alignItems: 'center', gap: '10px',
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(201,168,76,0.15)',
                  borderRadius: '4px', padding: '10px 14px',
                }}>
                  <span style={{ fontFamily: 'monospace', fontSize: '13px', color: 'var(--text-primary)', flex: 1, wordBreak: 'break-all' }}>
                    {USDT_WALLET}
                  </span>
                  <button onClick={copyWallet} style={{
                    background: copied ? 'rgba(29,158,117,0.15)' : 'rgba(201,168,76,0.1)',
                    border: `1px solid ${copied ? '#1D9E75' : 'rgba(201,168,76,0.2)'}`,
                    borderRadius: '4px', padding: '6px 12px',
                    color: copied ? '#1D9E75' : 'var(--gold)',
                    fontSize: '12px', cursor: 'pointer', fontFamily: 'var(--font-sans)',
                    transition: 'all 0.2s', whiteSpace: 'nowrap',
                  }}>
                    {copied ? '✓ Copied' : 'Copy'}
                  </button>
                </div>
              </div>

              {/* Warning */}
              <div style={{
                background: 'rgba(226,75,74,0.08)',
                border: '1px solid rgba(226,75,74,0.2)',
                borderRadius: '4px', padding: '10px 14px',
                fontSize: '12px', color: '#E24B4A', lineHeight: 1.6,
              }}>
                ⚠️ Only send USDT on the <strong>TRC20 network</strong>. Sending on the wrong network will result in permanent loss of funds.
              </div>
            </div>

            <div style={{
              background: 'rgba(255,255,255,0.02)',
              border: '1px solid rgba(255,255,255,0.06)',
              borderRadius: '8px', padding: '16px 20px',
            }}>
              <div style={{ fontSize: '13px', color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                After sending payment:
              </div>
              <ol style={{ marginTop: '8px', paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {[
                  'Take a screenshot of your transaction',
                  'Copy your transaction hash (TxID)',
                  'Click Continue and fill in your details',
                ].map((s, i) => (
                  <li key={i} style={{ fontSize: '13px', color: 'var(--text-primary)', lineHeight: 1.6 }}>{s}</li>
                ))}
              </ol>
            </div>

            <button onClick={() => setStep(2)} style={{
              background: 'var(--gold)', color: 'var(--ink)',
              border: 'none', borderRadius: '4px', padding: '14px',
              width: '100%', fontSize: '14px', fontWeight: 500,
              cursor: 'pointer', fontFamily: 'var(--font-sans)',
              letterSpacing: '0.04em', transition: 'background 0.2s',
            }}
              onMouseEnter={e => e.target.style.background = '#E8C97A'}
              onMouseLeave={e => e.target.style.background = 'var(--gold)'}
            >
              I've Sent Payment — Continue →
            </button>
          </div>
        )}

        {/* ---- STEP 2: Enrollment Form ---- */}
        {step === 2 && (
          <>
            {status === 'success' ? (
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>🎓</div>
                <h3 style={{ fontFamily: 'var(--font-serif)', fontSize: '22px', color: 'var(--gold)', marginBottom: '10px' }}>
                  Enrollment Received!
                </h3>
                <p style={{ fontSize: '14px', color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                  Welcome to PMG Academy. Our team at <strong style={{ color: 'var(--text-primary)' }}>info@pmg.today</strong> will verify your payment and reach out with next steps within 24 hours.
                </p>
                <button onClick={onClose} style={{
                  marginTop: '24px', background: 'var(--gold)', color: 'var(--ink)',
                  border: 'none', borderRadius: '4px', padding: '12px 28px',
                  fontSize: '14px', fontWeight: 500, cursor: 'pointer',
                  fontFamily: 'var(--font-sans)',
                }}>Close</button>
              </div>
            ) : (
              <form ref={formRef} onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>

                <div>
                  <label style={labelStyle}>Full Name {req}</label>
                  <input style={inputStyle} type="text" name="full_name"
                    placeholder="Enter your full name" value={form.full_name}
                    onChange={handleChange} required onFocus={focus} onBlur={blur} />
                </div>

                <div>
                  <label style={labelStyle}>Sex {req}</label>
                  <select style={{ ...inputStyle, cursor: 'pointer' }} name="sex"
                    value={form.sex} onChange={handleChange} required onFocus={focus} onBlur={blur}>
                    <option value="" style={{ background: '#141720' }}>Select...</option>
                    <option value="Male" style={{ background: '#141720' }}>Male</option>
                    <option value="Female" style={{ background: '#141720' }}>Female</option>
                    <option value="Other" style={{ background: '#141720' }}>Other</option>
                    <option value="Prefer not to say" style={{ background: '#141720' }}>Prefer not to say</option>
                  </select>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                  <div>
                    <label style={labelStyle}>Nationality {req}</label>
                    <input style={inputStyle} type="text" name="nationality"
                      placeholder="e.g. Nigerian" value={form.nationality}
                      onChange={handleChange} required onFocus={focus} onBlur={blur} />
                  </div>
                  <div>
                    <label style={labelStyle}>Postal Code {req}</label>
                    <input style={inputStyle} type="text" name="postal_code"
                      placeholder="e.g. 100001" value={form.postal_code}
                      onChange={handleChange} required onFocus={focus} onBlur={blur} />
                  </div>
                </div>

                <div>
                  <label style={labelStyle}>Email {req}</label>
                  <input style={inputStyle} type="email" name="email"
                    placeholder="you@example.com" value={form.email}
                    onChange={handleChange} required onFocus={focus} onBlur={blur} />
                </div>

                <div>
                  <label style={labelStyle}>Any tech skills already? Specify.</label>
                  <textarea style={{ ...inputStyle, minHeight: '80px', resize: 'vertical' }}
                    name="tech_skills" placeholder="e.g. HTML, Python basics, Figma..."
                    value={form.tech_skills} onChange={handleChange}
                    onFocus={focus} onBlur={blur} />
                </div>

                {/* Payment proof */}
                <div style={{
                  background: 'rgba(201,168,76,0.04)',
                  border: '1px solid rgba(201,168,76,0.15)',
                  borderRadius: '8px', padding: '16px',
                  display: 'flex', flexDirection: 'column', gap: '14px',
                }}>
                  <div style={{ fontSize: '12px', letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--gold)' }}>
                    Payment Proof
                  </div>
                  <div>
                    <label style={labelStyle}>Transaction Hash / TxID {req}</label>
                    <input style={inputStyle} type="text" name="tx_hash"
                      placeholder="Paste your TxID here e.g. abc123def456..."
                      value={form.tx_hash} onChange={handleChange}
                      required onFocus={focus} onBlur={blur} />
                  </div>
                  <div>
                    <label style={labelStyle}>Screenshot Description {req}</label>
                    <textarea style={{ ...inputStyle, minHeight: '70px', resize: 'vertical' }}
                      name="screenshot_note"
                      placeholder="Describe your screenshot e.g. 'Binance USDT TRC20 transfer, 9.99 USDT, April 6 2025' — and email the screenshot to info@pmg.today"
                      value={form.screenshot_note} onChange={handleChange}
                      required onFocus={focus} onBlur={blur} />
                    <div style={{ fontSize: '11px', color: 'var(--text-secondary)', marginTop: '6px' }}>
                      Also email your screenshot directly to <strong style={{ color: 'var(--gold)' }}>info@pmg.today</strong>
                    </div>
                  </div>
                </div>

                <div>
                  <label style={labelStyle}>Date {req}</label>
                  <input style={inputStyle} type="date" name="date"
                    value={form.date} onChange={handleChange}
                    required onFocus={focus} onBlur={blur} />
                </div>

                {status === 'error' && (
                  <p style={{ fontSize: '13px', color: '#E24B4A', textAlign: 'center' }}>
                    Something went wrong. Please email us at info@pmg.today
                  </p>
                )}

                <div style={{ display: 'flex', gap: '10px' }}>
                  <button type="button" onClick={() => setStep(1)} style={{
                    background: 'transparent', color: 'var(--text-secondary)',
                    border: '1px solid rgba(255,255,255,0.1)', borderRadius: '4px',
                    padding: '14px 20px', fontSize: '14px', cursor: 'pointer',
                    fontFamily: 'var(--font-sans)',
                  }}>← Back</button>
                  <button type="submit" style={{
                    background: 'var(--gold)', color: 'var(--ink)',
                    border: 'none', borderRadius: '4px', padding: '14px',
                    flex: 1, fontSize: '14px', fontWeight: 500,
                    cursor: 'pointer', fontFamily: 'var(--font-sans)',
                    letterSpacing: '0.04em',
                    opacity: status === 'sending' ? 0.7 : 1,
                    transition: 'background 0.2s',
                  }}>
                    {status === 'sending' ? 'Submitting...' : 'Submit Enrollment'}
                  </button>
                </div>

              </form>
            )}
          </>
        )}
      </div>
    </div>
  );
}
